import React, { useState } from "react";
import '../../Styles/PC/PCHeader.css'; // Import the specific CSS file
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';

function PCHeader() {

    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        navigate('/Admin');
    };
    return (
        <div className="pc-header">
            <div className="logo-container">
                <h1 className="logo-text">ciana</h1>
            </div>
            <div className="user-profile">
                <div className="" id="u-pic" style={{ cursor: 'pointer' }}>
                    <img src="./images/user.jpg" className='h-8 rounded-md ' id="profile" alt='user-img' />
                </div>
                <div className="relative cursor-pointer" id="dropdown">
                    <IconButton
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <ArrowDropDownIcon id="md-arrow" />
                    </IconButton>
                </div>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={logout} id="logout">
                        Logout
                    </MenuItem>
                </Menu>
            </div>
            {/* <KeyboardArrowDownIcon className="dropdown-icon" /> */}
        </div>
    );
}

export default PCHeader;